<div [kalLoading]="loading$ | async"
     class="gup-C-benefParamsMain__list">

    <h2 class="gup-O-titrage__title">{{ title }}</h2>

    <kal-button (click)="navigateToCreation()"
       class="gup-C-moreInfos gup-O-link"
       id="subvention_attribution_list_add">
        <kal-icon>add</kal-icon>
        <span>{{ addButtonLabel }}</span>
    </kal-button>

    <p>
        <kal-checkbox [formControl]="showArchiveControl"
                      label="{{displayArchiveToggleLabel}}"
                      id="subvention_attribution_list_show_archived">
        </kal-checkbox>
    </p>

    <kal-list [dataSource]="allocationsList$ | async"
              [selectionMode]="null"
              [selection]="selection"
              icon="keyboard_arrow_right"
              id="subvention_attribution_list">
        <ng-template kalListItem let-item="item">
            <span [ngClass]="{'gup-U-color--400': item.IsCloture}">
                {{ item.Libelle }}
            </span>
            <span *ngIf="item.Code" class="gup-U-color--400">&nbsp;- {{item.Code}}</span>
        </ng-template>

    </kal-list>

</div>
